<template>
  <v-form class="form">
    <div>
      <div class="header mb-6">
        <div>번호를 남겨주시면 연락드릴게요</div>
        <div v-if="onClose" class="d-flex justify-end">
          <v-icon color="default" @click="onClose()">mdi-close</v-icon>
        </div>
      </div>
      <div class="content">
        <div class="content-header">체험단 유형*</div>

        <div class="d-flex" style="gap: 8px">
          <img
            :src="
              require('@/assets/img/members-type/' +
                (formData.type === 'STORE' ? 'store_active.png' : 'store_inactive.png'))
            "
            @click="updateForm({ type: 'STORE' })"
            width="160px"
            height="210px"
            style="cursor: pointer" />
          <img
            :src="
              require('@/assets/img/members-type/' +
                (formData.type === 'PRODUCT' ? 'product_active.png' : 'product_inactive.png'))
            "
            @click="updateForm({ type: 'PRODUCT' })"
            width="160px"
            height="210px"
            style="cursor: pointer" />
        </div>
      </div>
    </div>
    <div class="content-container">
      <div class="content">
        <div class="content-header">업체명*</div>
        <NaverAutoComplete
          :companyName.sync="formData.name"
          :x.sync="formData.x"
          :y.sync="formData.y"
          :roadAddress.sync="formData.roadAddress" />
      </div>
      <div class="content">
        <div class="content-header">연락처*</div>
        <v-text-field
          v-model="formattedContact"
          name="contact"
          ref="contact"
          class="font-13"
          label="연락처를 입력해주세요"
          outlined
          solo
          flat
          single-line
          v-validate="'required|phoneNumber'"
          placeholder="010-0000-0000"
          :rules="[errors.first('contact') || !errors.has('contact')]"
          maxLength="13"></v-text-field>
      </div>
      <div v-if="formData.type === 'PRODUCT'" class="content">
        <div class="content-header">이메일*</div>
        <v-text-field
          v-model="formData.email"
          name="email"
          type="email"
          class="font-13"
          outlined
          solo
          flat
          required
          single-line
          v-validate="'required|email'"
          placeholder="이메일을 입력해주세요"
          :rules="[errors.first('email') || !errors.has('email')]"></v-text-field>
      </div>

      <div class="content">
        <div class="content-header">개인정보 수집/활용 동의 *</div>
        <div>
          <div class="checkbox-container">
            <v-checkbox
              v-model="isAllAgreed"
              label="모두 동의합니다."
              color="var(--primary-light-color)"
              class="checkbox-primary"
              hide-details />
          </div>
          <div class="checkbox-sub-container">
            <v-checkbox
              v-model="isPrivacyAgreed"
              v-validate="'required|truthy'"
              name="isPrivacyAgreed"
              ref="isPrivacyAgreed"
              label="[필수] 개인정보 수집∙이용에 동의합니다."
              color="var(--primary-light-color)"
              class="checkbox"
              hide-details />
            <v-checkbox
              v-model="isMarketingAgreed"
              label="[선택] 주요 공지사항 및 마케팅 수신에 동의합니다."
              color="var(--primary-light-color)"
              class="checkbox"
              hide-details />
            <div v-if="!formData.isMarketingAgreed" class="ml-7 marketing-notice">
              주차별 마케팅 성과 및 혜택 알림을 보내드려요.
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-form>
</template>

<script>
import NaverAutoComplete from '@/components/company/search/NaverAutoComplete.vue';

export default {
  name: 'LeadForm',
  components: {
    NaverAutoComplete,
  },

  model: {
    prop: 'formData',
    event: 'update:formData',
  },

  props: {
    onClose: {
      type: Function,
    },
    formData: {
      type: Object,
      default: () => ({
        type: 'STORE',
        name: '',
        x: '',
        y: '',
        contact: '',
        email: '',
        isPrivacyAgreed: this.formData.isPrivacyAgreed || false,
        isMarketingAgreed: this.formData.isMarketingAgreed || false,
        roadAddress: '',
      }),
    },
    handleFormValid: {
      type: Function,
    },
  },

  watch: {
    formData: {
      handler() {
        this.$nextTick(async () => {
          const isValid = await this.$validator.validateAll();
          const checkAdsType =
            this.formData.type && (this.formData.type === 'STORE' || this.formData.type === 'PRODUCT');
          const hasCompanyName = (this.formData.name && this.formData.name.length > 0) || false;

          this.$emit('handleFormValid', isValid && checkAdsType && hasCompanyName);
        });
      },
      deep: true,
    },
  },

  computed: {
    isAllAgreed: {
      get() {
        return this.formData.isPrivacyAgreed && this.formData.isMarketingAgreed;
      },
      set(value) {
        this.updateForm({ isPrivacyAgreed: value, isMarketingAgreed: value });
      },
    },

    isPrivacyAgreed: {
      get() {
        return this.formData.isPrivacyAgreed;
      },
      set(value) {
        this.updateForm({ isPrivacyAgreed: value });
      },
    },

    formattedContact: {
      get() {
        return this.formatPhoneNumber(this.formData.contact);
      },
      set(value) {
        this.updateForm({ contact: value.replace(/[^0-9]/g, '') });
      },
    },

    isMarketingAgreed: {
      get() {
        return this.formData.isMarketingAgreed;
      },
      set(value) {
        this.updateForm({ isMarketingAgreed: value });
      },
    },
  },

  methods: {
    updateForm(data) {
      this.$emit('update:formData', { ...this.formData, ...data });
    },
    formatPhoneNumber(value) {
      const numbers = value.replace(/[^0-9]/g, '');

      if (!numbers) return '';
      switch (numbers.length) {
        case 1:
        case 2:
        case 3:
        case 4:
          return numbers;
        case 5:
        case 6:
          return numbers.replace(/(\d{2})(\d+)/, '$1-$2');
        case 7:
          return numbers.replace(/(\d{3})(\d+)/, '$1-$2');
        case 8:
          return numbers.replace(/(\d{2})(\d{3})(\d{3})/, '$1-$2-$3');
        case 9:
          return numbers.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3');
        case 10:
          return numbers.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
        case 11:
          return numbers.replace(/(\d{3})(\d{4})(\d+)/, '$1-$2-$3');
        default:
          return numbers;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../assets/scss/typo.scss';

.form {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 24px;
  font-size: 13px;
  color: #000;

  @media (min-width: 960px) {
    gap: 39px;
  }
}
.header {
  display: flex;
  justify-content: space-between;
  color: var(--default-color);
  width: 327px;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
}

.content-container {
  display: flex;
  flex-direction: column;
  width: 327px;
  gap: 24px;
}
.content-header {
  font-size: 13px;
  line-height: 16px;
  font-weight: 700;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.checkbox-container {
  color: #000;
  padding: 10px 12px;
  border-radius: 4px;
  border: 1px solid #c2c2c2;
  background: var(--disabled-1-color);
  margin-bottom: 8px;
}

.checkbox-sub-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 10px;
}

.checkbox-primary {
  margin: 0;
  padding: 0px;
  :deep(.v-label) {
    font-size: 13px;
    color: #000;
  }
}
.checkbox {
  margin: 0;
  padding: 0px;
  :deep(.v-label) {
    color: var(--default-1-color);
    font-size: 14px !important;
  }
}

.submit-button {
  width: 100%;
  height: 44px;
  border-radius: 4px;
  background-color: var(--primary-light-color);
  color: white;
}

::v-deep .v-text-field.v-text-field--solo .v-input__control {
  height: 40px;
  min-height: 40px;
}

::v-deep .v-text-field--outlined.v-text-field--single-line .v-input__slot {
  height: 40px;
  min-height: 40px;
}
::v-deep .v-input--selection-controls__input {
  margin-right: 4px;
}

::v-deep .v-input--selection-controls .v-label {
  letter-spacing: -1px;
}

::v-deep .v-input__control {
  flex-direction: row;
}

.marketing-notice {
  color: var(--primary-light-color);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -1px;
}
</style>
